<template>
  <div class="ai-teach-app-container">
    <div class="container-top">
      <div class="main-title">AI应用中心</div>
    </div>
    <div class="app-intro" v-if="appList.length > 0">
      <div class="title">能力介绍</div>
      <div class="text">{{ appList[currentRealIndex].description }}</div>
    </div>
    <div class="swiper-box" v-if="appList.length > 0">
      <Swiper
        :watchSlidesProgress="true"
        ref="swiperRef"
        @swiper="onSwiperReady"
        slidesPerView="4"
        :loop="true"
        :observer="true"
        :observeParents="true"
        :observeSlideChildren="true"
        :autoplay="{ delay: 3000, disableOnInteraction: false }"
        :modules="modules"
        class="swiper-content"
      >
        <SwiperSlide
          class="swiper-slide"
          v-for="(item, index) in appList"
          :key="index"
          @click="handleDetail(item)"
        >
          <div
            class="app-card"
            :class="{ active: currentRealIndex == index }"
            @mouseenter="onCardHover(index)"
            @mouseleave="onCardLeave"
          >
            <div class="app-card-index">
              <span v-if="index + 1 < 10">0</span>
              <span>{{ index + 1 }}</span>
            </div>
            <div class="app-card-img">
              <img :src="item.icon_url" />
            </div>
            <div class="app-card-bottom">
              <div class="app-card-info">
                <div class="app-card-title">{{ item.name }}</div>
                <!-- <div class="app-card-sub-title">{{ item.enname }}</div> -->
              </div>
              <div class="app-card-btn">
                <img
                  src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/26adb9b5a95f442d85e447f0102d76ee.png"
                />
              </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
    <div v-else>
      <div class="no-data">
        <Empty />
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, watch, inject } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js'
import SwiperCore, { Navigation, A11y, Autoplay, Pagination, EffectCoverflow } from 'swiper'
import 'swiper/swiper-bundle.min.css'
import { Empty } from 'zhs-components'
import { handleLogin } from '@/plugins/utils'

SwiperCore.use([Navigation, A11y, Autoplay, Pagination, EffectCoverflow])

const modules = [Navigation, A11y, Autoplay, Pagination, EffectCoverflow]

const props = defineProps({
  zhsRole: {
    type: Number || String,
    default: 0
  }
})

const $http = inject('$http')

const appList = ref([])
const currentRealIndex = ref(0)

const swiperRef = ref(null) // Swiper DOM ref
const swiperInstance = ref(null) // 实际 Swiper 实例

// 获取原始 Swiper 实例
const onSwiperReady = swiper => {
  swiperInstance.value = swiper
  currentRealIndex.value = swiper.realIndex

  swiper.on('slideChange', () => {
    currentRealIndex.value = swiper.realIndex
  })
}

// 鼠标悬浮某卡片时
const onCardHover = index => {
  swiperInstance.value.autoplay.stop()
  currentRealIndex.value = index
}

// 鼠标移出某卡片时
const onCardLeave = () => {
  swiperInstance.value.autoplay.start()
}

const getAppList = async () => {
  const data = await $http.getAiAppList({ type: 0, role: props.zhsRole })
  appList.value = data
}

const handleDetail = item => {
  if (Number(props.zhsRole) === 0) {
    handleLogin()
    return
  }
  if (item.has_auth == 0) {
    ElMessage.warning('暂无权限')
    return
  }
  window.open(item.jump_url)
}

watch(
  () => props.zhsRole,
  () => {
    getAppList()
  },
  {
    immediate: true
  }
)
</script>

<style lang="scss" scoped>
.ai-teach-app-container {
  height: 580px;
  width: 1440px;
  padding-top: 40px;
  padding: 0 80px;
  position: relative;
  .container-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    .main-title {
      color: #1c212a;
      font-family: 'Alibaba PuHuiTi';
      font-size: 32px;
      font-weight: 700;
      &::before {
        content: '';
        display: inline-block;
        width: 4px;
        height: 24px;
        background-color: #194189;
        margin-right: 8px;
      }
    }
  }
  .app-intro {
    padding-left: 527px;
    .title {
      color: #1c212a;
      font-family: 'PingFang SC';
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
    }
    .text {
      color: rgba(29, 33, 41, 0.9);
      font-family: 'PingFang SC';
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 28px; /* 200% */
      // width: 360px;
      height: 50px;
    }
  }
  .swiper-box {
    position: relative;
    margin-top: 24px;
    .swiper-content {
      width: 100%;
      margin: auto;
      padding-top: 30px;
    }
    .swiper-slide {
      // &.swiper-slide-active {
      //   .app-card {
      //     background-color: rgba(25, 65, 137, 1);
      //     .app-card-index {
      //       color: rgba(255, 255, 255, 0.9);
      //     }
      //     .app-card-bottom {
      //       .app-card-info {
      //         .app-card-title {
      //           color: #fff;
      //         }
      //         .app-card-sub-title {
      //           color: rgba(255, 255, 255, 0.5);
      //         }
      //       }
      //       .app-card-btn {
      //         img {
      //           display: block;
      //         }
      //       }
      //     }
      //   }
      // }
      .app-card {
        width: 302px;
        height: 320px;
        border-radius: 12px;
        background-color: #eee;
        padding: 16px 20px 28px;
        box-sizing: border-box;
        cursor: pointer;
        position: relative;
        transition: all 0.3s ease-in-out;
        &:hover {
          transform: translateY(-30px);
        }
        &.active {
          background-color: rgba(25, 65, 137, 1);
          .app-card-index {
            color: rgba(255, 255, 255, 0.9);
          }
          .app-card-img {
            transform: scale(1.05) rotate(12deg);
          }
          .app-card-bottom {
            .app-card-info {
              .app-card-title {
                color: #fff;
              }
              .app-card-sub-title {
                color: rgba(255, 255, 255, 0.5);
              }
            }
            .app-card-btn {
              img {
                display: block;
              }
            }
          }
        }
        .app-card-index {
          position: absolute;
          right: 20px;
          top: 16px;
          color: #1c212a;
          font-family: 'DINAlternate';
          font-size: 48px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
        }
        .app-card-img {
          width: 194px;
          height: 194px;
          transition: all 0.3s linear;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .app-card-bottom {
          margin-top: 15px;
          display: flex;
          justify-content: space-between;
          .app-card-info {
            flex: 1;
            .app-card-title {
              color: #1c212a;
              font-family: 'PingFang SC';
              font-size: 28px;
              font-style: normal;
              font-weight: 600;
            }
            .app-card-sub-title {
              color: #84909d;
              font-family: 'PingFang SC';
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 24px; /* 150% */
              margin-top: 4px;
              word-break: keep-all;
            }
          }
          .app-card-btn {
            width: 64px;
            height: 64px;
            img {
              width: 100%;
              height: 100%;
              display: none;
            }
          }
        }
      }
    }
  }
}
</style>
